import { maxLength, minLength } from '../../utils/form-validations';

export const useCaseFormType:any = {
    customApplication : 'Custom Application',
    grafanaDashboard : 'Grafana Dashboard',
}

// Define JSON schemas for validation
export const schemas:any = {
    customApplication: {
        type: 'object',
        properties: {
            use_case_name: {
                type: 'string',
                pattern: '^(?=.*[a-zA-Z])[a-zA-Z0-9 ]+$', // Allow letters, numbers, and spaces
                minLength: minLength, // Minimum length for the name
                maxLength: maxLength, // Maximum length for the name
                errorMessage: {
                    pattern: 'Use Case Name must contain at least one letter and can include numbers and spaces.',
                    minLength: 'Use Case Name must be at least 3 characters long.',
                    maxLength: 'Use Case Name must not exceed 50 characters.',
                },
            },
            application_name: {
                type: 'string',
                pattern: '^(?=.*[a-zA-Z])[a-zA-Z0-9@_]+$', // Only letters, numbers, @, and _ allowed, no spaces
                maxLength: maxLength,
                errorMessage: 'Application Name must contain letter and can include numbers, @, and _. Spaces are not allowed.',
            },
            application_url: {
                type: 'string',
                pattern: '^[^\\s]+$',//format: 'uri', // URL validation
                errorMessage: 'Application URL must be a valid URL (e.g., http://localhost:3001)',
            },
            component_name: {
                type: 'string',
                pattern: '^(?=.*[a-zA-Z])[a-zA-Z0-9@_]+$', // Must contain at least one letter, and can include numbers, @, and _
                maxLength: maxLength,
                errorMessage: 'Component Name must contain letter and can include numbers, @, and _. Spaces are not allowed.',
            },
            navigation_name: {
                type: 'string',
                pattern: '^(?=.*[a-zA-Z])[a-zA-Z0-9 ]+$', // Allow letters, numbers, and spaces
                maxLength: maxLength,
                minLength: minLength,
                errorMessage: {
                    pattern: 'Navigation Name must contain at least one letter and can include numbers and spaces.',
                    minLength: 'Navigation Name must be at least 3 characters long.',
                    maxLength: 'Navigation Name must not exceed 50 characters.',
                },
            },
            navigation_slug: {
                type: 'string',
                pattern: '^(?![_-]+$)(?![0-9_-]*[_-][0-9_-]*$)[a-zA-Z0-9_-]+$', // Enforce the specified rules
                maxLength: maxLength,
                errorMessage: 'Navigation Slug must contain only letters, numbers, or a combination of letters with underscores (_) or hyphens (-).Spaces are not allowed.',
            },
        },
        required: ['use_case_name', 'application_name', 'application_url', 'component_name', 'navigation_name', 'navigation_slug'],
        additionalProperties: true,
    },
    grafanaDashboard: {
        type: 'object',
        properties: {
            use_case_name: {
                type: 'string',
                pattern: '^(?=.*[a-zA-Z])[a-zA-Z0-9 ]+$',  // Allow letters, numbers, and spaces
                minLength: minLength, // Minimum length for the name
                maxLength: maxLength, // Maximum length for the name
                errorMessage: {
                    pattern: 'Use Case Name must contain at least one letter and can include numbers and spaces.',
                    minLength: 'Use Case Name must be at least 3 characters long.',
                    maxLength: 'Use Case Name must not exceed 50 characters.',
                },
            },
            navigation_name: {
                type: 'string',
                pattern: '^(?=.*[a-zA-Z])[a-zA-Z0-9 ]+$', // Allow letters, numbers, and spaces
                maxLength: maxLength,
                minLength: minLength,
                errorMessage: {
                    pattern: 'Navigation Name must contain at least one letter and can include numbers and spaces.',
                    minLength: 'Navigation Name must be at least 3 characters long.',
                    maxLength: 'Navigation Name must not exceed 50 characters.',
                },
            },
            navigation_slug: { type: 'string', minLength: 1, maxLength: maxLength, errorMessage: 'Navigation Slug is required' },
            template_id: { type: 'string', errorMessage: 'Please select a valid Grafana Template' },
            template_config: { type: 'object', minProperties: 1, errorMessage: 'Custom Schema is required' },
            // onto_manage_id: { type: 'number', minLength: 1, errorMessage: 'Ontology Selection is required' },
        },
        required: ['use_case_name', 'navigation_name', 'navigation_slug', 'template_id', 'template_config'],
        additionalProperties: true,
    },
    jsonTemplateForm: {
        type: 'object',
        properties: {
            template_name: { type: 'string', pattern: '^(?=.*[a-zA-Z])[a-zA-Z0-9 ]+$', minLength: 1, maxLength: maxLength, errorMessage: 'Template Name must contain at least one letter and can include numbers and spaces.' },
            selected_template: { type: 'string', minLength: 1, errorMessage: 'Select Option is required' },
            template_config: { type: 'object', minProperties: 1, errorMessage: 'Schema is required' },
            template_description: { type: 'string', minLength: 1, errorMessage: 'Description is required' },
        },
        required: ['template_name', 'template_config', 'selected_template', 'template_description'],
        additionalProperties: true,
    },
};

export const stepperConfig:any = {
    customApplication: [
        {
            label: 'Use Case',
            fields: [
                { name: 'use_case_name', label: 'Use Case Name', type: 'text', required: true },
            ],
        },
        {
            label: 'Application Configuration',
            fields: [
                { name: 'application_name', label: 'Application Name', type: 'text', required: true },
                { name: 'application_url', label: 'Application URL', type: 'text', required: true },
                { name: 'component_name', label: 'Component Name', type: 'text', required: true },
            ],
        },
        {
            label: 'Navigation Configuration',
            fields: [
                { name: 'navigation_name', label: 'Navigation Name', type: 'text', required: true },
                { name: 'navigation_slug', label: 'Navigation Slug', type: 'text', required: true },
                { name: 'navigation_icon', label: 'Navigation Icon', type: 'file', required: true },
            ],
        },
    ],
    grafanaDashboard: [
        {
            label: 'Use Case',
            fields: [
                { name: 'use_case_name', label: 'Use Case Name', type: 'text', required: true },
            ],
        },
        {
            label: 'Navigation Config',
            fields: [
                { name: 'navigation_name', label: 'Navigation Name', type: 'text', required: true },
                { name: 'navigation_slug', label: 'Navigation Slug', type: 'text', required: true },
                { name: 'navigation_icon', label: 'Navigation Icon', type: 'file', required: true },
            ],
        },
        {
            label: 'Template Config',
            fields: [
                { name: 'template_id', label: 'Grafana Template', type: 'select', required: true },
                { name: 'template_config', label: 'Custom Schema', type: 'json', required: true },
            ],
        },
        {
            label: 'Assets Config',
            fields: [
                { name: 'onto_manage_id', label: 'Ontology Selection', type: 'ontology' },
                { name: 'assets_ids', label: 'List of Asset(s)', type: 'checkboxList' },
            ],
        },
        {
            label: 'Data Source',
            fields: [
                { name: 'variable_mapping', label: 'Variable Mapping', type: 'dataGrid' },
            ],
        },
    ],
};